import { GetAppPage } from "@/features/login/GetAppPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(auth)/get-app")({
  component: GetAppPage,
});